import { computed } from "vue"
import { useAuthStore } from "@/store/authentication"

// Checks if principal has specific permission
export const hasPermission = permission => computed(() => useAuthStore().getPermissions.includes(permission.value))
// Checks if principal has all of parameter permissions
export const hasPermissionsOfAll = permissions => computed(() => permissions.every(r => hasPermission(r).value))
// Checks if principal has at least one of parameter permissions
export const hasPermissionsOfAtLeastOne = permissions => computed(() => !!permissions.find(r => hasPermission(r).value))
